import {
  PracticeTabs,
} from '@/components/platform/Learn/pages/CourseTopic/components/MobilePractice/MobilePracticeTabs/PracticeTabs.constants';

export const practiceTabURLToPracticeTabs = (
  practiceTab: string,
): PracticeTabs => {
  switch (practiceTab) {
    case PracticeTabs.Tests:
      return PracticeTabs.Tests;
    case PracticeTabs.Browser:
      return PracticeTabs.Browser;
    case PracticeTabs.TaskSolution:
      return PracticeTabs.TaskSolution;
    case PracticeTabs.Editor:
    default:
      return PracticeTabs.Editor;
  }
};
